import React from 'react';
import { Mui, MuiIcons } from '@osu/react-ui';
import { STEP_STATUS } from '../../utils/constants';

/**
 * StepStatusChip Component
 * Displays the current status of a step with appropriate styling and messaging
 */
function StepStatusChip({ step }) {
  if (!step) return null;

  // Don't show status chip for condensed or grayed out steps
  if (step.showCondensed || step.showGrayedOut) {
    return null;
  }

  const getStatusConfig = () => {
    const hasActions = step.actions && step.actions.length > 0;

    switch (step.status) {
      case STEP_STATUS.IN_PROGRESS:
        return {
          label: hasActions ? 'Action Available' : 'In Progress',
          color: hasActions ? 'warning' : 'primary',
          icon: hasActions ? <MuiIcons.NotificationImportant /> : <MuiIcons.Schedule />,
          variant: 'filled'
        };

      case STEP_STATUS.COMPLETE:
        // Don't show chip for completed steps - step icons already indicate completion
        return null;

      case STEP_STATUS.PENDING:
        return {
          label: 'Pending',
          color: 'default',
          icon: <MuiIcons.Schedule />,
          variant: 'outlined'
        };

      default:
        return null;
    }
  };

  const statusConfig = getStatusConfig();

  if (!statusConfig) return null;

  return (
    <Mui.Box sx={{ mb: 2 }}>
      <Mui.Chip
        icon={statusConfig.icon}
        label={statusConfig.label}
        color={statusConfig.color}
        variant={statusConfig.variant}
        size="small"
        sx={{
          fontWeight: 'medium',
          '& .MuiChip-icon': {
            fontSize: '1rem'
          }
        }}
      />
    </Mui.Box>
  );
}

export default StepStatusChip;